// extracted by mini-css-extract-plugin
export default {"iconColor":"#fbf4ed","text":"#412304","lightBrown":"#e3c19a"};